import type { UserInfoGenerateVO } from '~/types/auto/oj';
import type {
  PersonalInfo,
  PreferenceInfo,
  UpdateUserRequestVO,
  UserVO,
} from '~/types/user';
import { httpService } from './http';

export function getSignInUserInfo(adtag?: string) {
  return httpService.get<UserVO>(`/api/code-community/api/get-user-info`, {
    query: { adtag, distinguish: 1 },
  });
}

export function fillUserInfo(data: UpdateUserRequestVO) {
  return httpService.post<UserVO>(`/api/code-community/api/fill-user-info`, {
    body: data,
    headers: httpService.COMMON_HEADERS,
  });
}

export function bindPhoneNumber(data: UpdateUserRequestVO) {
  return httpService.post<UserVO>(`/api/code-community/api/bind-user-phone`, {
    body: data,
    headers: httpService.COMMON_HEADERS,
  });
}

export function getPersonalInfo() {
  return httpService.get<UserVO>(`/api/code-community/api/get-personal-info`);
}

export function personalInfoSet(data: PersonalInfo) {
  return httpService.post(`/api/code-community/api/personal-info-set`, {
    body: data,
  });
}

export function preferenceInfoSet(data: PreferenceInfo) {
  return httpService.post(`/api/code-community/api/preference-info-set`, {
    body: data,
  });
}

export function setUserDefault() {
  return httpService.post(`/api/code-community/api/set-user-default`, {});
}

export function setUserNickname(data: {
  avatar: string;
  nickname: string;
  uid: string;
}) {
  return httpService.post(`/api/code-community/api/set-user-nickname`, {
    body: data,
  });
}

export function generateUserInfo() {
  return httpService.post<UserInfoGenerateVO>(
    `/api/code-community/api/generate-user-info`,
    {},
  );
}

// 收集用户的编程水平
export function gatherCodeLevel(data: { codeLevel: number }) {
  return httpService.post(`/api/code-community/api/gather-code-level`, {
    body: data,
  });
}
